import {
  Card as BaseCard,
  Skeleton as BaseSkeleton,
  Spinner as BaseSpinner,
  TableCell as BaseTableCell
} from '@chilecompra/react-kit/components'
import { Search as BaseSearchIcon } from '@mui/icons-material'
import { Grid as BaseGrid, TableContainer as BaseTableContainer, styled } from '@mui/material'
import React from 'react'
import { Link as BaseLink } from 'react-router-dom'

export const BaseContainer = styled(props => <BaseGrid container {...props} />)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const BaseItem = styled(props => <BaseGrid item {...props} />)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const Card = styled(BaseCard)`
  &.MuiPaper-root {
    display: flex;

    &.not__found {
      align-items: center;
      justify-content: center;
      min-height: 320px;

      .MuiGrid-container {
        height: 100%;
        text-align: center;
      }
    }
  }
`

export const Container = styled(BaseContainer)``

export const DialogButtons = styled(BaseContainer)``

export const DialogContent = styled(BaseContainer)``

export const DialogMessage = styled(BaseContainer)``

export const InfoIcon = styled('img')`
  height: 64px;
  pointer-events: none;
  user-select: none;
  width: 64px;
`

export const Item = styled(BaseItem)``

export const Link = styled(({ ...props }) => <BaseLink {...props} />)`
  align-items: center;
  color: ${props => (props.disabled ? props.theme.palette.brand.disableFont : props.theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-weight: 400;
  pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.gray[50]};
  height: auto;
  pointer-events: none;
  user-select: none;
  width: 82px;
`

export const SearchIcon = styled(({ disabled, ...props }) => <BaseSearchIcon {...props} />)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.gray[50]};
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    height: 24px;
    margin-right: 8px;
    pointer-events: ${props => (props.disabled ? 'none' : 'visible')};
    width: 24px;

    &:hover {
      color: ${props => props.theme.palette.blue[50]};
    }
  }
`

export const SearchLoadingIcon = styled(props => <BaseSpinner {...props} size="18px" />)`
  &.MuiCircularProgress-root {
    margin-right: 8px;
  }
`

export const Skeleton = styled(BaseSkeleton)`
  &.MuiSkeleton-root {
    transform: none;
  }
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
    vertical-align: middle;
  }
`

export const TableContainer = styled(BaseTableContainer)`
  &.void__table__container .MuiTable-root {
    border: none;
    &:focus,
    &:focus-visible {
      border: none;
    }
  }
`
